import axios from 'axios'
import { getUserToken } from './userCredentials'

const api = axios.create({
  baseURL: "https://api.op.scipitutor.com/api",
  headers: {
    Accept: 'application/json',
    Authorization: 'Bearer ' + getUserToken()
  }
});

export default api;